import { useEffect, useRef } from 'react';

import { type FilterLegacy } from '@verantos-dev/types-cohorts';

export const useSubjectVariablesScroll = (
  conceptFilters: FilterLegacy[],
  numericFilters: FilterLegacy[]
) => {
  //
  // scroll to bottom of section when add filter actions
  //
  const headerRef = useRef<HTMLDivElement>(null);
  const dialogContentRef = useRef<HTMLDivElement>(null);
  const conceptFilterRef = useRef<HTMLDivElement>(null);
  const numericFilterRef = useRef<HTMLDivElement>(null);

  const headerHeight = Math.round(headerRef?.current?.clientHeight ?? 0) + 16;

  // scroll when a concept filter is added
  useEffect(() => {
    const componentDiv = dialogContentRef.current;
    const conceptFilterDiv = conceptFilterRef.current;

    if (conceptFilterDiv && componentDiv) {
      if (headerHeight + conceptFilterDiv.clientHeight - componentDiv.clientHeight > 0) {
        componentDiv.scrollTo({
          left: 0,
          top: headerHeight + conceptFilterDiv.clientHeight - componentDiv.clientHeight + 16,
          behavior: 'auto',
        });
      }
    }
  }, [conceptFilters.length, headerHeight]);

  // scroll when a numeric filter is added
  useEffect(() => {
    const componentDiv = dialogContentRef.current;
    const conceptFilterDiv = conceptFilterRef.current;
    const numericFilterDiv = numericFilterRef.current;

    let conceptFilterHeight = 0;
    if (conceptFilterDiv) {
      conceptFilterHeight = conceptFilterDiv.clientHeight + 16;
    }

    if (numericFilterDiv && componentDiv) {
      if (
        headerHeight +
          conceptFilterHeight +
          numericFilterDiv.clientHeight -
          componentDiv.clientHeight >
        0
      ) {
        componentDiv.scrollTo({
          left: 0,
          top:
            headerHeight +
            conceptFilterHeight +
            numericFilterDiv.clientHeight -
            componentDiv.clientHeight +
            16,
          behavior: 'auto',
        });
      }
    }
  }, [headerHeight, numericFilters.length]);

  return {
    headerRef,
    dialogContentRef,
    conceptFilterRef,
    numericFilterRef,
  };
};
